// Hook theme third-party scripts into Shopify Customer Privacy.
// https://shopify.dev/docs/api/customer-privacy
document.addEventListener('DOMContentLoaded', () => {
  let loaded = false;

  function trackingAllowed() {
    const cp = window.Shopify?.customerPrivacy;
    // Fail open if API missing or methods aren't ready
    if (!cp) return true;
    const analyticsAllowed = typeof cp.analyticsProcessingAllowed === 'function'
      ? cp.analyticsProcessingAllowed()
      : true;
    const marketingAllowed = typeof cp.marketingAllowed === 'function'
      ? cp.marketingAllowed()
      : true;
    return analyticsAllowed || marketingAllowed;
  }

  function loadScripts() {
    if (loaded || !trackingAllowed()) return;
    loaded = true;

    const gtmId = window.themeSettings?.gtm?.containerId || 'GTM-P2XTQBRM';
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer',gtmId);

    if (window.collectionHandle === 'tudor') {
      const fbPixelId = window.themeSettings?.facebook?.pixelId || '587553625849116';
      !function(f,b,e,v,n,t,s){
        if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window,document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', fbPixelId);
        fbq('track', 'PageView');
    }

    (function() {
      const privySiteId = window.themeSettings?.privy?.siteId || '9C7D94503EC79D502A115B0A';
      var _d_site = _d_site || privySiteId;
      var script = document.createElement('script');
      script.src = 'https://widget.privy.com/assets/widget.js';
      document.head.appendChild(script);
    })();
  }

  // IP Blocker is security, not marketing so always load
  const ipBlockerShopUrl = window.themeSettings?.ipBlocker?.shopUrl || 'chpremier.myshopify.com';
  const ipBlockerScript = document.createElement('script');
  ipBlockerScript.src = `https://apps-shopify.ipblocker.io/s/api/file/rigorously-script.js?shop=${ipBlockerShopUrl}`;
  ipBlockerScript.defer = true;
  document.head.appendChild(ipBlockerScript);

  if (!window.Shopify?.loadFeatures) {
    loadScripts();
    return;
  }

  window.Shopify.loadFeatures(
    [{ name: 'consent-tracking-api', version: '0.1' }],
    (error) => {
      if (error) {
        loadScripts();
        return;
      }
      loadScripts();
      document.addEventListener('visitorConsentCollected', loadScripts);
    }
  );
});
